import React, { useEffect, useState } from 'react';
import { ChevronLeft, Search, ArrowUpRight, User } from 'lucide-react';
import { BottomNav } from '../components/BottomNav';
interface NetworkPageProps {
  onBack: () => void;
  onDeveloperOfficeClick?: (developerId: number, developerName: string, tier?: 'gold' | 'silver' | 'bronze') => void;
  onDeveloperInfoClick?: (developerId: number, developerName: string) => void;
  onNetworkClick?: () => void;
  onInventoryClick?: () => void;
  onRMIClick?: () => void;
}
interface Developer {
  id: number;
  name: string;
  logo: string;
  projectCount: number;
  tier?: 'gold' | 'silver' | 'bronze';
  category: 'my-developers' | 'suggested';
}
export function NetworkPage({
  onBack,
  onDeveloperOfficeClick,
  onDeveloperInfoClick,
  onNetworkClick,
  onInventoryClick,
  onRMIClick
}: NetworkPageProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentSlide, setCurrentSlide] = useState(0);
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Slider data with real images
  const slides = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/fZBeLX9rU7ip5s5mA4GDv6/001-6.jpg',
    logo: 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
    name: 'MOUNTAIN VIEW'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/fZBeLX9rU7ip5s5mA4GDv6/001-6.jpg',
    logo: 'https://cdn.magicpatterns.com/uploads/e3xetC89TNSJtFzKEK9GJ9/OIP.McQBqob_yPFZovOPZDod3AHaHa.webp',
    name: 'PALM HILLS'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/fZBeLX9rU7ip5s5mA4GDv6/001-6.jpg',
    logo: 'https://cdn.magicpatterns.com/uploads/8vQhTfMrXW8bwweERT8mA7/OIP.xWHw7TazT7rFveGb0a9zNwHaHa.webp',
    name: 'HYDE PARK'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/fZBeLX9rU7ip5s5mA4GDv6/001-6.jpg',
    logo: 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
    name: 'MOUNTAIN VIEW'
  }];
  // Real Egyptian developers data with actual logos
  const developers: Developer[] = [
  // My Developers - Gold Tier
  {
    id: 1,
    name: 'Mountain View',
    logo: 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
    projectCount: 8,
    tier: 'gold',
    category: 'my-developers'
  }, {
    id: 2,
    name: 'Palm Hills',
    logo: 'https://cdn.magicpatterns.com/uploads/e3xetC89TNSJtFzKEK9GJ9/OIP.McQBqob_yPFZovOPZDod3AHaHa.webp',
    projectCount: 12,
    tier: 'gold',
    category: 'my-developers'
  }, {
    id: 3,
    name: 'Hyde Park',
    logo: 'https://cdn.magicpatterns.com/uploads/8vQhTfMrXW8bwweERT8mA7/OIP.xWHw7TazT7rFveGb0a9zNwHaHa.webp',
    projectCount: 6,
    tier: 'gold',
    category: 'my-developers'
  },
  // My Developers - Silver Tier
  {
    id: 4,
    name: 'Emaar Misr',
    logo: 'https://cdn.magicpatterns.com/uploads/wijYmcxqmndw1XGyexVnGN/Emaar-Misr-Logo.png',
    projectCount: 10,
    tier: 'silver',
    category: 'my-developers'
  }, {
    id: 5,
    name: 'Sodic',
    logo: 'https://cdn.magicpatterns.com/uploads/m7ECvP64WQu5Q5fDGkVyT2/OIP.heFoNUDluvlfTF84mNzC8AHaB6.webp',
    projectCount: 7,
    tier: 'silver',
    category: 'my-developers'
  },
  // My Developers - Bronze Tier
  {
    id: 6,
    name: 'Ora Developers',
    logo: 'https://cdn.magicpatterns.com/uploads/qiVDQQJwbWPnXu1qEPHnnJ/1655298523997.jpg',
    projectCount: 4,
    tier: 'bronze',
    category: 'my-developers'
  }, {
    id: 7,
    name: 'Tatweer Misr',
    logo: 'https://cdn.magicpatterns.com/uploads/vFd4y3e6VTvKmbjouHn6Df/OIP.WU0po8LB04ePZzUToFmyKQHaD2.webp',
    projectCount: 5,
    tier: 'bronze',
    category: 'my-developers'
  }, {
    id: 8,
    name: 'Inertia',
    logo: 'https://cdn.magicpatterns.com/uploads/gtoHa4YFoGm69rL7tSXhd6/OIP.8_yr1_3JwTWhYPh-6mszrAHaBG.webp',
    projectCount: 3,
    tier: 'bronze',
    category: 'my-developers'
  },
  // Suggested Developers
  {
    id: 9,
    name: 'Madinet Masr',
    logo: 'https://cdn.magicpatterns.com/uploads/ht2zed5WJfpibcGTs2kKAi/Mountain-View-Logo-Vector.svg-.png',
    projectCount: 6,
    category: 'suggested'
  }, {
    id: 10,
    name: 'City Edge',
    logo: 'https://cdn.magicpatterns.com/uploads/wijYmcxqmndw1XGyexVnGN/Emaar-Misr-Logo.png',
    projectCount: 8,
    category: 'suggested'
  }, {
    id: 11,
    name: 'Reportage Properties',
    logo: 'https://cdn.magicpatterns.com/uploads/m7ECvP64WQu5Q5fDGkVyT2/OIP.heFoNUDluvlfTF84mNzC8AHaB6.webp',
    projectCount: 5,
    category: 'suggested'
  }, {
    id: 12,
    name: 'Misr Italia',
    logo: 'https://cdn.magicpatterns.com/uploads/qiVDQQJwbWPnXu1qEPHnnJ/1655298523997.jpg',
    projectCount: 9,
    category: 'suggested'
  }, {
    id: 13,
    name: 'Hassan Allam Properties',
    logo: 'https://cdn.magicpatterns.com/uploads/vFd4y3e6VTvKmbjouHn6Df/OIP.WU0po8LB04ePZzUToFmyKQHaD2.webp',
    projectCount: 4,
    category: 'suggested'
  }, {
    id: 14,
    name: 'Sabbour Consulting',
    logo: 'https://cdn.magicpatterns.com/uploads/gtoHa4YFoGm69rL7tSXhd6/OIP.8_yr1_3JwTWhYPh-6mszrAHaBG.webp',
    projectCount: 7,
    category: 'suggested'
  }, {
    id: 15,
    name: 'Arabia Holding',
    logo: 'https://cdn.magicpatterns.com/uploads/e3xetC89TNSJtFzKEK9GJ9/OIP.McQBqob_yPFZovOPZDod3AHaHa.webp',
    projectCount: 3,
    category: 'suggested'
  }, {
    id: 16,
    name: 'Wadi Degla',
    logo: 'https://cdn.magicpatterns.com/uploads/8vQhTfMrXW8bwweERT8mA7/OIP.xWHw7TazT7rFveGb0a9zNwHaHa.webp',
    projectCount: 5,
    category: 'suggested'
  }, {
    id: 17,
    name: 'Better Home',
    logo: 'https://cdn.magicpatterns.com/uploads/wijYmcxqmndw1XGyexVnGN/Emaar-Misr-Logo.png',
    projectCount: 6,
    category: 'suggested'
  }, {
    id: 18,
    name: 'Rooya Group',
    logo: 'https://cdn.magicpatterns.com/uploads/m7ECvP64WQu5Q5fDGkVyT2/OIP.heFoNUDluvlfTF84mNzC8AHaB6.webp',
    projectCount: 4,
    category: 'suggested'
  }];
  const myDevelopers = developers.filter(dev => dev.category === 'my-developers' && dev.name.toLowerCase().includes(searchQuery.toLowerCase()));
  const suggestedDevelopers = developers.filter(dev => dev.category === 'suggested' && dev.name.toLowerCase().includes(searchQuery.toLowerCase()));
  const getTierBadge = (tier?: 'gold' | 'silver' | 'bronze') => {
    if (!tier) return null;
    const tierConfig = {
      gold: {
        label: 'GOLD',
        bg: 'bg-yellow-600',
        text: 'text-white'
      },
      silver: {
        label: 'SILVER',
        bg: 'bg-gray-400',
        text: 'text-white'
      },
      bronze: {
        label: 'BRONZE',
        bg: 'bg-orange-600',
        text: 'text-white'
      }
    };
    const config = tierConfig[tier];
    return <span className={`absolute top-3 right-3 ${config.bg} ${config.text} text-[10px] font-bold px-2 py-1 rounded`} data-id="element-1089">
        {config.label}
      </span>;
  };
  const getTierButtonColor = (tier?: 'gold' | 'silver' | 'bronze') => {
    if (!tier) return 'text-secondary';
    const tierColors = {
      gold: 'text-yellow-600',
      silver: 'text-gray-500',
      bronze: 'text-orange-600'
    };
    return tierColors[tier];
  };
  const handleEnterOffice = (developer: Developer) => {
    if (onDeveloperOfficeClick) {
      onDeveloperOfficeClick(developer.id, developer.name, developer.tier);
    }
  };
  const handleGetAccredited = (developer: Developer) => {
    if (onDeveloperInfoClick) {
      onDeveloperInfoClick(developer.id, developer.name);
    }
  };
  const currentSlideData = slides[currentSlide];
  return <div className="min-h-screen bg-neutral-bg pb-20 font-sans w-full" data-id="element-1090">
      <div className="w-full mx-auto bg-neutral-bg min-h-screen relative" data-id="element-1091">
        {/* Header */}
        <div className="bg-primary px-4 py-4 safe-top flex items-center justify-between sticky top-0 z-10 shadow-sm" data-id="element-1092">
          <button onClick={onBack} className="p-2 -ml-2 text-white hover:bg-white/10 rounded-full transition-colors" data-id="element-1093">
            <ChevronLeft className="w-6 h-6" data-id="element-1094" />
          </button>
          <h1 className="font-semibold text-lg text-white" data-id="element-1095">Network</h1>
          <div className="w-10" data-id="element-1096"></div>
        </div>

        {/* Slider */}
        <div className="px-4 pt-6 pb-4" data-id="element-1097">
          <div className="relative" data-id="element-1098">
            <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-1099">
              {/* Project Image */}
              <div className="relative h-64" data-id="element-1100">
                <img src={currentSlideData.image} alt={currentSlideData.name} className="w-full h-full object-cover" data-id="element-1101" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" data-id="element-1102"></div>
              </div>

              {/* Developer Logo and Info */}
              <div className="p-6 flex flex-col items-center -mt-16 relative z-10" data-id="element-1103">
                <div className="w-24 h-24 mb-4 bg-white rounded-full p-3 shadow-lg flex items-center justify-center" data-id="element-1104">
                  <img src={currentSlideData.logo} alt={currentSlideData.name} className="w-full h-full object-contain" data-id="element-1105" />
                </div>

                <h2 className="text-xl font-bold text-neutral-text mb-4 tracking-wide" data-id="element-1106">
                  {currentSlideData.name}
                </h2>

                <button className="bg-primary text-white px-8 py-2.5 rounded-full text-sm font-semibold hover:bg-primary-dark transition-colors" data-id="element-1107">
                  Connect
                </button>
              </div>
            </div>

            {/* Slider dots */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-1108">
              {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-colors ${index === currentSlide ? 'bg-primary' : 'bg-gray-300'}`} data-id="element-1109" />)}
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div className="px-4 pb-4" data-id="element-1110">
          <div className="relative" data-id="element-1111">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1112" />
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search by Developer Name or Served area." className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent" data-id="element-1113" />
          </div>
        </div>

        {/* Suggested Developers Section - Horizontal Scroll */}
        <div className="pb-6" data-id="element-1114">
          <h2 className="text-base font-bold text-neutral-text mb-4 px-4" data-id="element-1115">
            Suggested Developers
          </h2>
          <div className="overflow-x-auto no-scrollbar" data-id="element-1116">
            <div className="flex gap-3 px-4" data-id="element-1117">
              {suggestedDevelopers.map(developer => <div key={developer.id} className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden relative flex-shrink-0 w-[160px]" data-id="element-1118">
                  {/* Logo */}
                  <div className="p-6 flex items-center justify-center border-b border-gray-100 h-32" data-id="element-1119">
                    <img src={developer.logo} alt={developer.name} className="w-full h-full object-contain" data-id="element-1120" />
                  </div>

                  {/* Content */}
                  <div className="p-4" data-id="element-1121">
                    <h3 className="font-bold text-sm text-neutral-text mb-1 line-clamp-2" data-id="element-1122">
                      {developer.name}
                    </h3>
                    <p className="text-xs text-gray-500 mb-3" data-id="element-1123">
                      {developer.projectCount} Projects
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-col gap-2" data-id="element-1124">
                      <button onClick={() => handleGetAccredited(developer)} className="flex items-center justify-center gap-1 text-xs font-medium text-secondary hover:opacity-80 transition-opacity w-full py-1.5 bg-secondary/10 rounded-lg" data-id="element-1125">
                        <User className="w-3.5 h-3.5" data-id="element-1126" />
                        <span data-id="element-1127">Get Accredited</span>
                      </button>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* My Developers Section */}
        <div className="px-4 pb-6" data-id="element-1128">
          <h2 className="text-base font-bold text-neutral-text mb-4" data-id="element-1129">
            My Developers
          </h2>
          <div className="grid grid-cols-2 gap-3" data-id="element-1130">
            {myDevelopers.map(developer => <div key={developer.id} className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden relative" data-id="element-1131">
                {getTierBadge(developer.tier)}

                {/* Logo */}
                <div className="p-6 flex items-center justify-center border-b border-gray-100 h-32" data-id="element-1132">
                  <img src={developer.logo} alt={developer.name} className="w-full h-full object-contain" data-id="element-1133" />
                </div>

                {/* Content */}
                <div className="p-4" data-id="element-1134">
                  <h3 className="font-bold text-sm text-neutral-text mb-1" data-id="element-1135">
                    {developer.name}
                  </h3>
                  <p className="text-xs text-gray-500 mb-3" data-id="element-1136">
                    {developer.projectCount} Projects
                  </p>

                  {/* Action Buttons */}
                  <div className="flex items-center justify-between" data-id="element-1137">
                    <button onClick={() => handleEnterOffice(developer)} className={`flex items-center gap-1 text-xs font-medium ${getTierButtonColor(developer.tier)} hover:opacity-80 transition-opacity`} data-id="element-1138">
                      <User className="w-3.5 h-3.5" data-id="element-1139" />
                      <span data-id="element-1140">Enter office</span>
                    </button>
                    <button className={`p-1.5 ${getTierButtonColor(developer.tier)} hover:opacity-80 transition-opacity`} data-id="element-1141">
                      <ArrowUpRight className="w-4 h-4" data-id="element-1142" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        <BottomNav onNetworkClick={onNetworkClick} onInventoryClick={onInventoryClick} onRMIClick={onRMIClick} activeNav="network" data-id="element-1143" />
      </div>
    </div>;
}